import { motion, type HTMLMotionProps } from 'framer-motion'

type RevealProps = HTMLMotionProps<'div'> & { delay?: number; y?: number; as?: 'div' | 'li' }

/** Fade + rise on first scroll into view. */
export function Reveal({ delay = 0, y = 24, as = 'div', children, ...props }: RevealProps) {
  const Comp = (as === 'li' ? motion.li : motion.div) as typeof motion.div
  return (
    <Comp
      initial={{ opacity: 0, y, filter: 'blur(6px)' }}
      whileInView={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      {...props}
    >
      {children}
    </Comp>
  )
}
